import { Observable } from "rxjs";

import { Wallet } from "@app/core/wallet/domain/model/wallet";

export abstract class WalletRepo {
  abstract find(): Observable<Wallet>;
}
